<script setup>
// Vue Imports
import { computed } from 'vue'
import { APP } from "@/config/app";
import { useRoute } from 'vue-router';
import { addUtm } from '@/utils/utmParameter';

// Component Logic
const cdn = import.meta.env.VITE_CDN_MWI_BASE_URL
const currentYear = computed(() => { const today = new Date(); return today.getFullYear(); })
const route = useRoute()

const pageRoutes = [
  {
    title: "Home",
    route: APP.MyWealthWebsite,
  },
  {
    title: "Global Index Service",
    route: `${APP.MyWealthWebsite}/global-index-service`,
  },
  {
    title: "Self-Select Service",
    route: `${APP.MyWealthWebsite}/self-select-service`,
  },
  {
    title: "News",
    route: `${APP.MyWealthWebsite}/news`,
  },
  {
    title: "Get In Touch",
    route: `${APP.MyWealthWebsite}/get-in-touch`,
  },
]
</script>

<!--<template>-->
<!--  <footer class="bg-teal text-white dark:bg-mwi-rebrand-green-alt">-->
<!--    <div class="flex flex-col gap-10 mx-auto max-w-7xl py-20 px-8 xl:px-0">-->
<!--      &lt;!&ndash; navigation items &ndash;&gt;-->
<!--      <div-->
<!--          class="border-b border-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-14 lg:gap-y-0 gap-x-8 pb-10"-->
<!--      >-->
<!--        <div class="col-span-2 md:col-span-1">-->
<!--          <a href="/">-->
<!--            <img-->
<!--                :src="`${cdn}/logos/mwi-logo-white-strap-line.svg`"-->
<!--                alt="My Wealth invest icon"-->
<!--            />-->
<!--          </a>-->
<!--        </div>-->
<!--        <div class="col-span-1 flex flex-col gap-y-6">-->
<!--          <a-->
<!--              v-for="link in pageRoutes"-->
<!--              :href="link.route"-->
<!--              :aria-label="`${link.title} link`"-->
<!--              class="body-2-semi-bold"-->
<!--              target="_blank"-->
<!--          >-->
<!--            {{ link.title }}-->
<!--          </a>-->
<!--        </div>-->
<!--        <div class="col-span-1">-->
<!--          <h4 class="body-2-semi-bold mb-6">More Information</h4>-->
<!--          <div class="small-text-1-reg flex flex-col gap-4">-->
<!--            <a-->
<!--                :href="`${APP.MyWealthWebsite}/privacynotice`"-->
<!--                rel="noopener noreferrer"-->
<!--                target="_blank"-->
<!--            >Privacy Notice</a>-->
<!--            <a-->
<!--                :href="`${APP.MyWealthWebsite}/termsconditions`"-->
<!--                target="_blank"-->
<!--            >Terms and Conditions</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--            class="col-span-2 md:col-span-3 lg:col-span-1 flex lg:flex-col items-center lg:items-end justify-center sm:justify-end lg:justify-start gap-4 md:gap-12"-->
<!--        >-->
<!--          <a-->
<!--              href="https://apps.apple.com/gb/app/my-wealth-invest/id6443942288"-->
<!--              target="_blank"-->
<!--              aria-label="Download on the apple app store link"-->
<!--          >-->
<!--            <img-->
<!--                :src="`${cdn}/icons/apple-store-icon.svg`"-->
<!--                alt="Apple store icon"-->
<!--            />-->
<!--          </a>-->
<!--          <a-->
<!--              href="https://play.google.com/store/apps/details?id=com.wealth_at_work.mobile_app.prod&pli=1"-->
<!--              target="_blank"-->
<!--              aria-label="Download on the google play app store link"-->
<!--          >-->
<!--            <img-->
<!--                :src="`${cdn}/icons/google-play-icon.svg`"-->
<!--                alt="Google play icon"-->
<!--            />-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div>-->
<!--        <p class="small-text-1-reg">&copy; {{ currentYear }} Wealth at Work Ltd. All rights reserved.</p>-->
<!--      </div>-->
<!--    </div>-->
<!--  </footer>-->
<!--</template>-->
<template>
  <footer class="bg-teal text-white">
    <div class="flex flex-col gap-8 mx-auto max-w-7xl py-20 px-8 xl:px-4">
      <!-- navigation items -->
      <div
        class="border-b border-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-14 lg:gap-y-0 gap-x-8 pb-8"
      >
        <div class="col-span-2 md:col-span-1">
          <a :href="addUtm('/')">
            <img
              :src="`${cdn}/logos/mywealth-invest-white.svg`"
              alt="My Wealth invest icon"
              :class="route.path === '/' ? 'hover:cursor-auto' : 'hover:underline'"
            />
          </a>
        </div>
        <template>
          <div class="col-span-1 flex flex-col gap-y-4">
            <a
              v-for="(link, index) in pageRoutes"
              :key="index"
              :href="addUtm(link.route)"
              :aria-label="`${link.title} link`"
              class="body-2-semi-bold"
              :class="
                route.path === link.route
                  ? 'hover:cursor-auto'
                  : 'hover:underline'
              "
            >
              {{ link.title }}
            </a>
          </div>
          <div class="lg:col-span-2 flex flex-col gap-5 md:gap-0 lg:items-end justify-between">
          <div>
            <p class="body-2-semi-bold mb-6">More Information</p>
            <div class="body-4-light flex flex-col gap-4">
              <a :href="addUtm('/privacynotice')"
                :class="route.path === '/privacynotice' ? 'hover:cursor-auto' : 'hover:underline'"
              >
                Privacy Notice
              </a>
              <a :href="addUtm('/termsconditions')"
                :class="route.path === '/termsconditions' ? 'hover:cursor-auto' : 'hover:underline'"
              >
                Terms and Conditions
              </a>
            </div>
          </div>
          <div
            class="flex flex-col md:flex-row items-start lg:items-end justify-center sm:justify-end lg:justify-start gap-4 md:gap-12">
            <a href="https://apps.apple.com/gb/app/my-wealth-invest/id6443942288"
              target="_blank"
              aria-label="Download on the apple app store link"
            >
              <img
                :src="`${cdn}/icons/apple-store-icon.svg`"
                alt="Apple store icon"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.wealth_at_work.mobile_app.prod&pli=1"
              target="_blank"
              aria-label="Download on the google play app store link"
            >
              <img
                :src="`${cdn}/icons/google-play-icon.svg`"
                alt="Google play icon"
              />
            </a>
          </div>
        </div>
        </template>
      </div>
      <div class="body-4-light flex flex-col gap-4">
        <p class="!text-sm">Important Risk Warning: No advice is offered in the provision of the self-invested personal pension (SIPP), the ISA or the general investment account (GIA) provided by my wealth invest. Tax treatment will depend on your individual circumstances and is subject to change in future. The value of your investments may go down as well as up, and you could get back less than your initial investment. During any transfer, your investment will be out of the market. ISA rules and terms & conditions apply. Seek independent financial advice if you are unsure of the suitability of any investment. my wealth invest is a trading name of Wealth at Work Limited which is authorised and regulated by the Financial Conduct Authority and is part of the Wealth at Work group. Registered in England and Wales No. 05225819. Registered Office: Third Floor, 5 St Paul’s Square, Liverpool, L3 9SJ. Calls may be recorded and monitored for training and record-keeping purposes.</p>
        <p class="text-xs">
          &copy; {{ currentYear }} Wealth at Work Ltd. All rights reserved. my wealth invest is a trading name of Wealth at Work Limited which is authorised and
          regulated by the Financial Conduct Authority and is part of the Wealth at Work group. Registered in England and Wales No.05225819. Registered Office:
          Third Floor, 5 St Paul’s Square, Liverpool L3 9SJ.
        </p>
      </div>
    </div>
  </footer>
</template>